import { render, staticRenderFns } from "./UiLabel.vue?vue&type=template&id=5cf4c1f3&lang=pug&"
import script from "./UiLabel.vue?vue&type=script&lang=ts&"
export * from "./UiLabel.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports